import { mdmRegistry, tranformerInfoObj } from '../features/mdm/mdmRegistry';
import { ChannelkartNetworkPost } from '../services/networkService'
import { openPopup } from '../stateManagement/actions/popupActions';
import store from '../stateManagement/store';
import { configurationAttributeType } from '../types';
import { task } from './reportService';
import JSZip from 'jszip';
import { getMetaDataConfig } from './uiConfigService';

export async function uploadFile(formData: FormData, useKafka?:boolean){

    try {
        let url = useKafka == true ? "/v1/uploadFile/mdmkafkauploads" : "/v1/uploadFile/mdmuploads";
        const response = await ChannelkartNetworkPost(url, formData,{"Content-Type": "multipart/form-data"});
        return response.data.features;
    }
    catch(err:any){
        return(err.message);
    }
}

export async function validateZipContent(file: File): Promise<boolean> {
    if (file.name.split(".").pop()?.toLowerCase() !== 'zip') {
        return false; 
    }
    try {
        const portalConfig = await getMetaDataConfig("clientconfig", "portal_configuration");
        const portal_config: configurationAttributeType[] = portalConfig?.domainValues ?? [];
        const maxSizeKB = portal_config?.find((item) => item.name === "maxZipFileSize")?.value ?? 50;
        const zip = new JSZip();
        const zipContent = await zip.loadAsync(file);

        for (const filename in zipContent.files) {
            const zipEntry = zipContent.files[filename];

            if (zipEntry.dir) continue;
            
            if (
                filename.startsWith('__MACOSX/') ||
                filename.endsWith('.DS_Store') ||
                filename.startsWith('.') ||
                filename.includes('/.')
            ) {
                continue;
            }
            const metadata = await zipEntry.async('blob').then(blob => {
                const sizeKB = blob.size / 1024;
                return { sizeKB };
            });
            
            if (metadata.sizeKB > maxSizeKB) {
                console.warn(`File ${filename} in zip exceeds size limit: ${metadata.sizeKB.toFixed(2)}KB > ${maxSizeKB}KB`);
                return false; 
            }
        }
        return true; 
    } catch (error) {
        console.error("Error checking zip file:", error);
        return false; 
    }
}


export const donwloadReportWithStatus = async (id: string,setLoader:React.Dispatch<React.SetStateAction<boolean>>) => {
    const res = await task(id);
    let data = res.data.features[0];
    if (data.status === "SUCCESS") {
        setLoader(false);
        openPopup("Success", "File has been uploaded. Please Check Logs");
    } else if (data.status === "INPROGRESS") {
      setTimeout(() => donwloadReportWithStatus(id,setLoader), 2000);
    } else {
      setLoader(false);
      openPopup("Error", "File Upload Failed. Please check Logs");
    }
  };

export async function mdmDataUpload(data:FormData,entityname:string,fileToBeUploaded:any,setLoader:React.Dispatch<React.SetStateAction<boolean>>, useKafka?:boolean, transformerInfo?:string | tranformerInfoObj[]){
    try{
        if (fileToBeUploaded.name.split(".").pop()?.toLowerCase() === 'zip') {
            const isValidSize = await validateZipContent(fileToBeUploaded);
            if (!isValidSize) {
                setLoader(false);
                openPopup("Error", "Upload aborted. One or more files in the zip exceed 50KB size limit.");
                return;
            }
        }
        const uploadedFile = await uploadFile(data, useKafka);
        const uri = uploadedFile[0].Uri
        const url = processFile(fileToBeUploaded, useKafka);
        const transformer = transformerInfo ?? store?.getState()?.mdmReducer?.transformerInfo;
        let dataObj = {} as any;
        dataObj['attributes']={
            entityName: entityname,
            lob: localStorage.getItem("lob"),
            transformerInfo : transformer,
            filePath:uri,
            ...(useKafka ? { type: "xlsx" } : {}),
            ...(store?.getState()?.mdmReducer?.chainingJobName
                ? { chainingJobName: store.getState().mdmReducer.chainingJobName }
                : {}),
        }
        const response = await ChannelkartNetworkPost(url, dataObj);
        donwloadReportWithStatus(response.data.id,setLoader);
    }
    catch(error:any){
        setLoader(false);
        openPopup("Error", "File Upload Failed. Please check Logs");
        return(error.message);
    }
    
}

export function getTransformer(entityname:string, file:File){

    var transformerInfo = {};
    const filetype = file.name.split(".").pop();

    if(entityname === "User"){
        transformerInfo = [{
            "entityName": entityname,
            "transformerId": "mdm_" + entityname.toLowerCase()
        }]
    }
    else if(entityname === "OutletDetails"){
        transformerInfo = [{
            "entityName": "User",
            "transformerId": "mdm_" + entityname.toLowerCase() + "_user",
            "operationType": "merge"
        },
        {
            "entityName": entityname,
            "transformerId": "mdm_" + entityname.toLowerCase()
        },
        ]
    }else if(entityname === "ProductDetails" && filetype === "xlsx"){
        transformerInfo = [{
            "entityName": entityname,
            "transformerId": "mdm_" + entityname.toLowerCase()
        },
        {
            "entityName": "ProductMetaData",
            "transformerId": "mdm_productmetadata"
        },
        ]
    }else if(entityname === "RecommendedOrder"){
        transformerInfo = [
            {
                "entityName": "RecommendedOrder",
                "transformerId": "recommendation_order"
            }
        ]
    }else if(entityname === "SellinaAIQuery"){
        transformerInfo = [
            {
                "entityName": "SellinaAIQuery",
                "transformerId": "default_faq1"
            }
        ]
    }else if(entityname === "TranslationInfo"){
        transformerInfo = [
            {
                "entityName": "TranslationInfo",
                "transformerId": "mdm_translation_info"
            }
    ]
    }else if(entityname === "UserEvent"){
        transformerInfo = [
            {
                "entityName": "UserEvent",
                "transformerId": "mdm_user_event"
            }
        ]
    }else if(entityname === "SchemeDefination"){
        transformerInfo = [
            {
                "entityName": "SchemeDefination",
                "transformerId": "ilc_transformer"
            }
        ]
    }else{
        transformerInfo = [{
            "entityName": entityname,
            "transformerId": "default_" + entityname.toLowerCase()
        }]
    }

    return transformerInfo;

}

export function processFile(file:any, useKafka?:boolean){
    const fileType: string = file.name.split(".").pop();

    const fileUrl:string = fileType === 'zip'? '/tasks/types/blobcreater/execute' : useKafka == true ? '/tasks/types/mdmkafkaupload/execute' : '/tasks/types/mdmupload/execute';

    return fileUrl;
}
